import React, { useEffect, useRef, useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { StyledTextField } from './styledComponents';

interface Props {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    hidden?: boolean;
    value: string;
    placeholder?: string;
    inputRef?: React.MutableRefObject<HTMLInputElement | null>;
    styles?: { [name: string]: string };
    label?: string;
}
const PasswordField = ({
    onChange,
    hidden,
    value,
    placeholder,
    inputRef,
    styles = {},
    label = 'Password',
}: Props) => {
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (!hidden && inputRef?.current) {
            inputRef.current.focus();
        }
    }, [hidden, inputRef]);

    const handleTogglePassword = () => {
        setShowPassword(prev => !prev);
    };

    return (
        <StyledTextField
            style={styles}
            inputRef={inputRef}
            hidden={hidden}
            fullWidth
            label={label}
            placeholder={placeholder}
            type={showPassword ? 'text' : 'password'}
            variant="standard"
            margin="normal"
            value={value}
            onChange={onChange}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={handleTogglePassword}
                            edge="end"
                            sx={{ color: 'gray' }}
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
export default PasswordField;
